import React from 'react';
type PropsT = {
  minorDistance: number;
  minorCount: number;
  minorStrokeWidth: number;
  majorStrokeWidth: number;
  color: string;
};
const Grid = ({
  minorDistance,
  minorCount,
  minorStrokeWidth,
  majorStrokeWidth,
  color
}: PropsT) => {
  const majorGridSize = minorDistance * minorCount;
  return <svg height="100%" width="100%" data-grid-svg="true">
      <defs>
        <pattern id="smallGrid" width={minorDistance} height={minorDistance} patternUnits="userSpaceOnUse">
          <path d={`M ${minorDistance} 0 L 0 0 0 ${minorDistance}`} fill="none" stroke={color} strokeWidth={minorStrokeWidth} />
        </pattern>
        <pattern id="grid" width={majorGridSize} height={majorGridSize} patternUnits="userSpaceOnUse">
          <rect width={majorGridSize} height={majorGridSize} fill="url(#smallGrid)" />
          <path d={`M ${majorGridSize} 0 L 0 0 0 ${majorGridSize}`} fill="none" stroke={color} strokeWidth={majorStrokeWidth} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>;
};
Grid.defaultProps = {
  minorDistance: 10,
  minorCount: 3,
  minorStrokeWidth: 0.5,
  majorStrokeWidth: 1,
  color: 'gray'
};
export default Grid;